import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@knockrentals/knock-shared-web-v2';
import { MARKETING_MEDIA_FIELDS } from '../constants';

const { PROPERTY_WEBSITE } = MARKETING_MEDIA_FIELDS;

const PropertyWebsite = ({
  clearFieldErrorMessage,
  propertyWebsite,
  updateMarketingMedia,
  validationErrorMessage,
}) => {
  const handleOnChange = (value) => {
    updateMarketingMedia({ [PROPERTY_WEBSITE]: value });
  };

  const handleOnFocus = () => {
    clearFieldErrorMessage(PROPERTY_WEBSITE);
  };

  const handleOnBlur = (e) => {
    const { value } = e.target;
    updateMarketingMedia({ [PROPERTY_WEBSITE]: value.trim() });
  };

  return (
    <TextField
      error={Boolean(validationErrorMessage)}
      fullWidth
      helperText={validationErrorMessage}
      label="Property Website"
      id={PROPERTY_WEBSITE}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      onFocus={handleOnFocus}
      placeholder="https://"
      value={propertyWebsite || ''}
      variant="outlined"
    />
  );
};

PropertyWebsite.propTypes = {
  clearFieldErrorMessage: PropTypes.func,
  propertyWebsite: PropTypes.string,
  updateMarketingMedia: PropTypes.func,
  validationErrorMessage: PropTypes.string,
};

export default PropertyWebsite;
